import triangle from "../../../../assets/documents/triangle.svg";
import { isTerminal } from "../../../../constants";

export const emploumentData = [

    {
        id:"hr-head-1",
        title:"тип",
        icon:triangle,
        width:isTerminal ? "325px" : "325px",
    },
    {
        id:"hr-head-2",
        title:"наименование",
        icon:"",
        width:isTerminal ? "400px" : "400px",
    },
    {
        id:"hr-head-3",
        title:"дата поступления",
        icon:"",
        width:isTerminal ? "125px" : "125px",
    },
    {
        id:"hr-head-4",
        title:"статус",
        icon:"",
        width:isTerminal ? "150px" : "150px",
    },

];
